import { useEffect, useRef, useState } from "react";
import { amenityDayTimeline } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function DayAtAuburn() {
  const [active, setActive] = useState(0);
  const refs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = Number((entry.target as HTMLElement).dataset["index"]);
            setActive(index);
          }
        });
      },
      { rootMargin: "-45% 0px -45% 0px" },
    );
    refs.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="day-at-auburn"
      aria-labelledby="day-heading"
      className="bg-background py-16 md:py-20"
    >
      <div className="shell">
        <Reveal>
          <Eyebrow>A Day at Your Base Camp</Eyebrow>
        </Reveal>
        <h2 id="day-heading" className="display-lg mt-6 max-w-[16ch]">
          <MaskReveal>Recharge Here.</MaskReveal>
          <MaskReveal delay={0.08}>Adventure Out There.</MaskReveal>
        </h2>
      </div>

      <div className="shell mt-10 hidden lg:block">
        <div className="max-w-3xl">

          <div>
            {amenityDayTimeline.map((item, i) => (
              <div
                key={item.id}
                data-index={i}
                ref={(el) => {
                  refs.current[i] = el;
                }}
                className="flex min-h-[70vh] flex-col justify-center border-b border-border/70 py-10 last:border-b-0"
              >
                <span className="eyebrow text-muted-foreground">{item.label}</span>
                <h3 className="display-md mt-6 max-w-[16ch]">{item.title}</h3>
                <p className="mt-6 max-w-md text-base leading-relaxed text-muted-foreground">
                  {item.copy}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="shell mt-10 space-y-8 lg:hidden">
        {amenityDayTimeline.map((item, i) => (
          <Reveal key={item.id} delay={i * 0.05}>
            <article>
              <span className="eyebrow mt-6 block text-muted-foreground">{item.label}</span>
              <h3 className="display-md mt-3">{item.title}</h3>
              <p className="mt-4 text-base leading-relaxed text-muted-foreground">{item.copy}</p>
            </article>
          </Reveal>
        ))}
      </div>

      <div className="shell mt-8">
        <Reveal>
          <ResortLink variant="solid" href="/nearby-attractions/" className="w-full sm:w-auto">
            Explore Nearby Attractions
          </ResortLink>
        </Reveal>
      </div>
    </section>
  );
}
